import qwest from 'qwest';

export function getPrivacyPolicy(locale = 'en-US') {
  return qwest.get('/Info/PrivacyPolicy?locale=' + locale)
    .then((xhr, res) => res)
    .then(data => {
      console.log(data);
      if (data && data.html) {
        return data.html;
      }
      throw new Error('Could not retrieve privacy policy.');
    })
    .catch(err => {
      console.error(err);
    });
}

export function getTermsOfUse(locale = 'en-US') {
  return qwest.get('/Info/TermsOfUse?locale=' + locale)
    .then((xhr, res) => res)
    .then(data => {
      if (data && data.html) {
        return data.html;
      }
      throw new Error('Could not retrieve terms of use.');
    })
    .catch(err => {
      console.error(err);
    });
}
